import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faSync, faClock } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './HorariosData.css';
import baseURL from '../../url';

export default function HorariosData() {
    const [timezone, setTimezone] = useState('America/Bogota');
    const [horarios, setHorarios] = useState([]);
    const [loading, setLoading] = useState(true);

    const diasSemana = ['Domingo y/o Festivo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    
    const zonas = [
        'America/Bogota',
        'America/Lima',
        'America/Mexico_City',
        'America/Argentina/Buenos_Aires',
        'America/Santiago',
        'America/Caracas',
        'America/La_Paz',
        'America/Guayaquil',
        'America/Panama',
        'America/Montevideo',
        'America/Asuncion',
        'America/New_York',
        'America/Los_Angeles',
        'Europe/Madrid',
    ];

    useEffect(() => {
        cargarHorarios();
    }, []);

    const cargarHorarios = () => {
        fetch(`${baseURL}/horariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setTimezone(data.timezone);
                    
                    // Inicializar horarios para todos los días
                    const horariosCompletos = diasSemana.map((dia, index) => {
                        const horarioExistente = data.horarios.find(h => h.dia_semana == index);
                        return horarioExistente || {
                            dia_semana: index,
                            apertura1: '',
                            cierre1: '',
                            apertura2: '',
                            cierre2: '',
                            activo: 0
                        };
                    });
                    
                    setHorarios(horariosCompletos);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error('Error al cargar horarios:', error);
                toast.error('Error al cargar horarios');
                setLoading(false);
            });
    };

    const handleHorarioChange = (index, campo, valor) => {
        const nuevosHorarios = [...horarios];
        nuevosHorarios[index][campo] = valor;
        setHorarios(nuevosHorarios);
    };

    const handleActivoChange = (index) => {
        const nuevosHorarios = [...horarios];
        nuevosHorarios[index].activo = nuevosHorarios[index].activo ? 0 : 1;
        
        // Si se desactiva, limpiar los horarios
        if (!nuevosHorarios[index].activo) {
            nuevosHorarios[index].apertura1 = '';
            nuevosHorarios[index].cierre1 = '';
            nuevosHorarios[index].apertura2 = '';
            nuevosHorarios[index].cierre2 = '';
        }
        
        setHorarios(nuevosHorarios);
    };

    const validarHorarios = () => {
        for (let i = 0; i < horarios.length; i++) {
            const h = horarios[i];
            
            if (h.activo) {
                // Debe tener al menos el rango 1
                if (!h.apertura1 || !h.cierre1) {
                    toast.error(`${diasSemana[i]}: Debe completar el primer rango de horario`);
                    return false;
                }
                
                if (h.apertura1 === h.cierre1) {
                    toast.error(`${diasSemana[i]}: Las horas de apertura y cierre no pueden ser iguales (Rango 1)`);
                    return false;
                }
                
                // Si tiene rango 2, validarlo
                if (h.apertura2 || h.cierre2) {
                    if (!h.apertura2 || !h.cierre2) {
                        toast.error(`${diasSemana[i]}: Complete ambos campos del segundo rango o déjelos vacíos`);
                        return false;
                    }
                    
                    if (h.apertura2 === h.cierre2) {
                        toast.error(`${diasSemana[i]}: Las horas de apertura y cierre no pueden ser iguales (Rango 2)`);
                        return false;
                    }
                    
                    // Solo validar solapamiento si ninguno cruza la medianoche
                    const cruza1 = h.apertura1 > h.cierre1;
                    const cruza2 = h.apertura2 > h.cierre2;
                    if (!cruza1 && !cruza2) {
                        if (h.apertura2 < h.cierre1) {
                            toast.error(`${diasSemana[i]}: Los rangos de horario no deben solaparse`);
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    };

    const guardarHorarios = () => {
        if (!validarHorarios()) {
            return;
        }

        Swal.fire({
            title: '¿Guardar cambios?',
            text: 'Se actualizarán los horarios de atención',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, guardar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    timezone: timezone,
                    horarios: horarios
                };

                fetch(`${baseURL}/horariosSave.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire('¡Guardado!', data.mensaje, 'success');
                            cargarHorarios();
                        } else {
                            toast.error(data.error || 'Error al guardar');
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        toast.error('Error al guardar horarios');
                    });
            }
        });
    };

    if (loading) {
        return <div className='loadingHorarios'>Cargando horarios...</div>;
    }

    return (
        <div className='horariosContainer'>
            <ToastContainer />
            
            <div className='horariosHeader'>
                <h2><FontAwesomeIcon icon={faClock} /> Horarios de Atención</h2>
                <div className='timezoneSelector'>
                    <label>Zona Horaria:</label>
                    <select value={timezone} onChange={(e) => setTimezone(e.target.value)}>
                        {zonas.map(zona => (
                            <option key={zona} value={zona}>{zona}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className='horariosTable'>
                {horarios.map((horario, index) => (
                    <div key={index} className={`horarioRow ${!horario.activo ? 'inactivo' : ''}`}>
                        <div className='horarioDia'>
                            <input
                                type='checkbox'
                                checked={horario.activo}
                                onChange={() => handleActivoChange(index)}
                            />
                            <span>{diasSemana[index]}</span>
                        </div>

                        {horario.activo ? (
                            <>
                                <div className='horarioRango'>
                                    <label>Rango 1:</label>
                                    <input
                                        type='time'
                                        value={horario.apertura1 || ''}
                                        onChange={(e) => handleHorarioChange(index, 'apertura1', e.target.value)}
                                    />
                                    <span>a</span>
                                    <input
                                        type='time'
                                        value={horario.cierre1 || ''}
                                        onChange={(e) => handleHorarioChange(index, 'cierre1', e.target.value)}
                                    />
                                </div>

                                <div className='horarioRango'>
                                    <label>Rango 2 (opcional):</label>
                                    <input
                                        type='time'
                                        value={horario.apertura2 || ''}
                                        onChange={(e) => handleHorarioChange(index, 'apertura2', e.target.value)}
                                    />
                                    <span>a</span>
                                    <input
                                        type='time'
                                        value={horario.cierre2 || ''}
                                        onChange={(e) => handleHorarioChange(index, 'cierre2', e.target.value)}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className='horarioCerrado'>
                                <span>Cerrado</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className='horariosActions'>
                <button className='btnGuardar' onClick={guardarHorarios}>
                    <FontAwesomeIcon icon={faSave} /> Guardar Cambios
                </button>
                <button className='btnRecargar' onClick={cargarHorarios}>
                    <FontAwesomeIcon icon={faSync} /> Recargar
                </button>
            </div>
        </div>
    );
}


